import styled from 'styled-components';

import {getColor, gts} from '@yourcoach/shared/styles/utils';
import {Text} from '@yourcoach/shared/uikit/Text';
import {View} from '@yourcoach/shared/uikit/View';

export const Container = styled(View)`
  flex-direction: column;
  gap: ${gts('gap.xxl')};
`;

export const ContainerActions = styled(Container)`
  gap: 0;
`;

export const ContainerItem = styled(Container)`
  flex-direction: row;
  align-items: center;
  justify-content: start;
  gap: ${gts('gap.la')};
`;

export const Header = styled(View)`
  gap: ${gts('gap.la')};
`;

export const DateContainer = styled(View)`
  align-items: center;
  gap: ${gts('gap.me')};
`;

export const Title = styled(Text).attrs({
  variant: 'label.la',
  weight: 'regular',
})``;

export const Description = styled(Text).attrs({
  variant: 'label.la',
  weight: 'regular',
})`
  color: ${getColor('text.gray')};
`;
